import { render } from "./HosManage.vue?vue&type=template&id=bcfdeefc&scoped=true"
import script from "./HosManage.vue?vue&type=script&lang=js"
export * from "./HosManage.vue?vue&type=script&lang=js"

import "./HosManage.vue?vue&type=style&index=0&id=bcfdeefc&lang=scss"
import "./HosManage.vue?vue&type=style&index=1&id=bcfdeefc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfdeefc"]])

export default __exports__